/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Acteur sélectionnable comme assureur, bénéficiaire de frais ou de commission.
 * @export
 * @interface ActeurMinimalDto
 */
export interface ActeurMinimalDto {
    /**
     * 
     * @type {string}
     * @memberof ActeurMinimalDto
     */
    id?: string;
    /**
     * Identifiant attendu par les commandes (assureurPersonneId, beneficiairePersonneId). Les acteurs sans personId ne sont pas sélectionnables.
     * @type {string}
     * @memberof ActeurMinimalDto
     */
    personId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActeurMinimalDto
     */
    label?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActeurMinimalDto
     */
    plateformeName?: string | null;
}

/**
 * Check if a given object implements the ActeurMinimalDto interface.
 */
export function instanceOfActeurMinimalDto(value: object): value is ActeurMinimalDto {
    return true;
}

export function ActeurMinimalDtoFromJSON(json: any): ActeurMinimalDto {
    return ActeurMinimalDtoFromJSONTyped(json, false);
}

export function ActeurMinimalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActeurMinimalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'personId': json['personId'] == null ? undefined : json['personId'],
        'label': json['label'] == null ? undefined : json['label'],
        'plateformeName': json['plateformeName'] == null ? undefined : json['plateformeName'],
    };
}

export function ActeurMinimalDtoToJSON(json: any): ActeurMinimalDto {
    return ActeurMinimalDtoToJSONTyped(json, false);
}

export function ActeurMinimalDtoToJSONTyped(value?: ActeurMinimalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'personId': value['personId'],
        'label': value['label'],
        'plateformeName': value['plateformeName'],
    };
}

